import { FormikDropdown, FormikSpinButton } from 'formik-office-ui-fabric-react'
import { FieldStackItem, FormStack } from 'forms/FormStack'
import { PersonType } from 'model'
import { IDropdownOption, Label } from 'office-ui-fabric-react'
import { Position } from 'office-ui-fabric-react/lib/utilities/positioning'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

export type ProvingDetailsParticipantsUnknownFormValues = {
  personType: PersonType
} & {
  amount: number
}

export const ProvingDetailsParticipantsUnknownForm: React.FC = () => {
  const { t } = useTranslation()

  const options: IDropdownOption[] = [
    { key: 'user', text: t('dropdown.option.pag') },
    { key: 'external', text: t('dropdown.option.dvt') },
    { key: 'supplier', text: t('dropdown.option.supplier') },
  ]

  return (
    <FormStack>
      <Label>{t('model.proving.participant.addUnknownParticipant')}</Label>
      <FieldStackItem
        name="personType"
        render={(fieldProps) => (
          <FormikDropdown
            label={t('field.participantType.label')}
            {...fieldProps}
            options={options}
            required={true}
          />
        )}
      />
      <FieldStackItem
        name={'amount'}
        render={(fieldProps) => (
          <FormikSpinButton
            label={t('field.amount.label')}
            labelPosition={Position.top}
            max={10}
            min={1}
            {...fieldProps}
          />
        )}
      />
    </FormStack>
  )
}
